// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Oaa-z","narrowOptionButtons":"Paa-z","noOptions":"Qaa-z"};